import {
    ADD_EDITABLE_COURSE_DATA,
    ADD_EDITABLE_COURSE_DRAWING_DATA,
    CREATE_NEW_COURSE_ERROR,
    CREATE_NEW_COURSE_SUCCESS,
    DELETE_COURSE_ERROR,
    DELETE_COURSE_START,
    DELETE_COURSE_SUCCESS,
    ELEVATION_CHART_HOVER,
    FETCH_COURSE_DETAILS_START,
    FETCH_COURSE_DETAIL_FAIL,
    FETCH_COURSE_DETAIL_SUCCESS,
    FETCH_COURSE_POINTS_SUCCESS,
    FETCH_COURSE_POPULAR_ROUTES_ERROR,
    FETCH_COURSE_POPULAR_ROUTES_SUCCESS,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ENDED,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ERROR,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_START,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_SUCCESS,
    FETCH_FAVORITE_COURSES_FAIL,
    FETCH_FAVORITE_COURSES_SUCCESS,
    FETCH_START_COURSE_POPULAR_ROUTES,
    FETCH_START_COURSE_ROUND_TRIP_ROUTE,
    GET_COURSE_ROUTE_SEGMENT,
    GET_COURSE_ROUTE_SEGMENT_ERROR,
    GET_COURSE_ROUTE_SEGMENT_SUCCESS,
    RECEIVE_COURSE_ROUND_TRIP_ROUTE,
    RECEIVE_COURSE_ROUND_TRIP_ROUTE_ERROR,
    RECEIVE_COURSES,
    RECEIVE_GROUP_COURSES,
    RECEIVE_WEB_GATEWAY_COURSES,
    RECEIVE_WEB_GATEWAY_COURSES_FOR_CHINA,
    REDO_COURSE_ROUTE_HISTORY,
    REMOVE_COURSE_FROM_FAVORITE,
    REMOVE_COURSE_FROM_FAVORITE_FAIL,
    REMOVE_COURSE_FROM_FAVORITE_SUCCESS,
    REQUEST_COURSES,
    REQUEST_GROUP_COURSES,
    RESET_CHANGING_FAVORITE_COURSE_STATUS_FAIL,
    RESET_CHART_SELECTED_AREA_START_END_VALUE,
    RESET_COURSE_ELEVATION_CHART_EXPANDED_STATUS,
    RESET_COURSE_POINT_SELECTION,
    RESET_DELETE_COURSE_ERROR_STATUS,
    RESET_EDITABLE_COURSE_DATA,
    RESET_EDITABLE_COURSE_DATA_ON_DRAWING_METHOD_CHANGED,
    RESET_EDITABLE_COURSE_DRAWING_DATA,
    DELETE_COURSE_POINTS_RESTS,
    DELETE_COURSE_POINTS_CUTOFFS,
    DELETE_COURSE_POINTS_NOTES,
    RESET_ELEVATION_CHART_HOVER,
    RESET_ELEVATION_CHART_SELECTED_GEO_POINTS,
    SET_CHART_SELECTED_AREA_START_END_VALUE,
    SET_COURSE_ELEVATION_CHART_EXPANDED_STATUS,
    SET_COURSE_POINT_SELECTION,
    SET_COURSE_TO_FAVORITE,
    SET_COURSE_TO_FAVORITE_FAIL,
    SET_COURSE_TO_FAVORITE_SUCCESS,
    SET_ELEVATION_CHART_SELECTED_GEO_POINTS,
    UNDO_COURSE_ROUTE_HISTORY,
    UPDATE_COURSE_DATA_ERROR,
    UPDATE_COURSE_DATA_SUCCESS,
    UPDATE_COURSE_PRIVACY_ERROR,
    UPDATE_COURSE_PRIVACY_SUCCESS,
    SET_COURSE_MARKER_DATA,
    RESET_COURSE_MARKER_DATA,
    REQUEST_NEARBY_COURSES,
    FETCH_NEARBY_COURSES_SUCCESS,
    FETCH_NEARBY_COURSES_ERROR,
    RESET_NEARBY_COURSES,
    FETCH_THIRD_PARTY_CONSUMER_INFO,
    RECEIVE_THIRD_PARTY_CONSUMER_INFO,
    REQUEST_CLIMBS,
    RECEIVE_CLIMBS,
    RESET_CACHED_CLIMBS,
    DUPLICATE_COURSE_SUCCESS,
    DUPLICATE_COURSE_ERROR,
    DUPLICATE_COURSE_START,
    FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_START,
    FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_SUCCESS,
    FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_ERROR,
    RESET_GEOPOINTS_FOR_COURSES_MINIMAP_LIST,
    REMOVE_CACHED_MINIMAP_ROUTE_BY_IDS,
    RESET_COURSES_LIST_SORT_VALUE,
    SET_COURSES_LIST_SORT_VALUE,
    SET_COURSES_LIST_FILTER_VALUE,
    RESET_COURSES_LIST_FILTER_VALUE,
    REQUEST_CLIMBS_ON_ROUTE,
    RECEIVE_CLIMBS_ON_ROUTE,
    REQUEST_CLIMBS_ON_COURSE,
    RECEIVE_CLIMBS_ON_COURSE,
    CONFIRM_ELEVATION_WAS_UPDATED_BY_API_FOR_COURSE,
    REQUEST_SECONDARY_CLIMBS,
    RECEIVE_SECONDARY_CLIMBS,
    RESET_SECONDARY_CLIMBS,
    RESET_CLIMBS_ON_ROUTE_OR_COURSE,
    FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_SUCCESS,
    FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_ERROR,
    REQUEST_COURSE_MAP_MATCH,
    REQUEST_COURSE_MAP_MATCH_DONE,
    RESET_COURSE_MAP_MATCH_STATUS,
    SET_MAP_BOUNDING_BOX,
    RESET_MAP_BOUNDING_BOX,
    RECEIVE_CLIMBS_FAILED,
    ADD_IMPORTED_COURSE_DATA,
    RESET_IMPORTED_COURSE_DATA,
    REQUEST_HAZARDS,
    RECEIVE_HAZARDS,
    RECEIVE_HAZARDS_FAILED,
    REQUEST_HAZARDS_ON_COURSE,
    RESET_HAZARDS,
    FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT_DONE,
    ENABLE_LAP_BY_COURSE_POINTS
} from '../../actions/ActionTypes.js';

import i18next from 'i18next';
import PaceProConstants from 'utils/pacePro/PaceProConstants';
import PowerGuidanceConstants from 'utils/powerGuidance/PowerGuidanceConstants';

import {
    Directions,
    DrawingMethods,
    filterCourseList,
    getCoordinateSystem,
    getGeoPointsFromCourseSegmentLines,
    getInitialObjectForHistoryFromCourseData,
    getNextCourseRouteHistory,
    getPointsChangedObject,
    getProcessedDataFromGeoPoints,
    RoutesDrawingTypes,
    RulesDTO,
    setCourseLines,
    setElevationIntoGeoPointsObject,
    setPointMarkerIdInCoursePoint,
    sortListByFilterValue,
    updateCourseMarkersDistanceBasedOnLines,
    updateLinesDataWithDistanceForEachPoint,
    setStartFinishCoursePoints,
    updateExistingCourseLinesWithElevation,
    filterCourseListByMapBounds,
    updateLapByCoursePoints,
    courseHasLapByCoursePoints,
    isLapByCoursePointsType,
    updateCourseRouteHistoryWithWithClimbsOnRoute
} from '../../Courses/Utils';

const INITIAL_STATE = {
    entity: [],
    webGatewayCourses: [],
    courseListSortType: null,
    courseListFilters: null,
    mapBoundingBox: null,
    // route history only records geoPoints and coursePoints so there is no need to update on editableCourseData update just on editableCourseData.geoPoints/coursePoints
    courseRouteHistory: { 0: getInitialObjectForHistoryFromCourseData() }, // used to keep the history of geoPoints - for undo and redo
    courseRouteHistoryIndex: 0, // used to keep track of the current history location on redo/undo
    importedCourse: null,
    editableCourseData: {
        activityTypePk: null,
        hasTurnDetectionDisabled: false,
        geoPoints: [],
        courseLines: [],
        boundingBox: null,
        coursePoints: null,
        distanceMeter: null,
        elevationGainMeter: null,
        elevationLossMeter: null,
        startPoint: null,
        elapsedSeconds: null,
        openStreetMap: false,
        coordinateSystem: getCoordinateSystem(null),
        rulePK: RulesDTO.private.id
    },
    fetchingCourseDetails: false,
    initialCourseDataWithNoChanges: null,
    editableCourseDrawingData: {
        mapRouteFetching: false,
        receivedRouteDoesNotHaveData: false,
        coursePoints: null,
        drawingMethod: { ...DrawingMethods[0] }, // this should not actually be sent to the API - it is just to handle drawing method and the initial value is custom
        routesDrawingType: { ...RoutesDrawingTypes.POPULAR_ROUTES }, // this should not actually be sent to the API - it is just to handle drawing method and the initial value is custom
        direction: Directions.NORTH, //default direction
        distance: null, // this is the selected value in the drawing options not distanceMeter from the course data
        createNewCourseId: null,
        courseTypeParent: null,
        inlineMode: false
    },
    group: [],
    favorite: [],
    details: {},
    coursesListFetching: false,
    coursesFetched: false,
    availableCoursePoints: null,
    coursePointSelection: {
        pointType: null,
        pointLocation: null,
        editModeMarkerInitialValue: null
    },
    courseLinesFetching: false,
    courseDuplicateFetching: false,
    isSettingFavoriteCourseInProgress: false,
    changingFavoriteCourseStatusFail: false,
    elevationChart: {
        courseElevationChartExpandedStatus: false,
        selectedGeoPoints: null,
        selectionStart: null,
        selectionEnd: null
    },
    coursePointMarkerData: {
        tempGeoPoints: [],
        tempLines: [],
        tempWorkInProgressPoint: null,
        tempCoursePointMarkers: []
    },
    deleteCourseInProgress: null,
    deleteCourseError: null,
    elevationChartHoverValue: null,
    nearbyCourses: null,
    nearbyCoursesTotalSearchHits: null,
    nearbyCoursesFetching: false,
    coursesListGeoPoints: {
        fetching: false,
        items: {}
    },
    boundingBoxError: false,
    consumers: [],
    climbs: [],
    cachedClimbs: {},
    climbsOnRouteOrCourse: [],
    climbsListFetching: false,
    climbsOnRouteFetching: false,
    climbsOnCourseFetching: false,
    secondaryClimbs: [],
    secondaryClimbsFetching: false,
    mapMatchState: {
        courseId: null,
        processing: false,
        error: false
    },
    hazards: [],
    hazardsFetching: false,
    lapByCoursePointsEnabled: false
};

const requestCourses = (state) => {
    return {
        ...state,
        coursesListFetching: true,
        coursesFetched: false
    };
};

const receiveCourses = (state, action) => {
    return {
        ...state,
        coursesListFetching: false,
        coursesFetched: true,
        entity: action.courses
    };
};

const deleteCourseStart = (state) => {
    return {
        ...state,
        deleteCourseInProgress: true,
        deleteCourseError: INITIAL_STATE.deleteCourseError
    };
};

const deleteCourseSuccess = (state, action) => {
    let updatedDetailsObject = {
        ...state.details
    };

    let newWebGatewayCourses =
        state.webGatewayCourses && state.webGatewayCourses.length
            ? [...state.webGatewayCourses]
            : state.webGatewayCourses;
    let newFavorite = state.favorite && state.favorite.length ? [...state.favorite] : state.favorite;
    let newNearbyCourses =
        state.nearbyCourses && state.nearbyCourses.length ? [...state.nearbyCourses] : state.nearbyCourses;

    //also remove from the list of courseDetails based on the id - the editableCourseData is handled on reset
    if (action && action.courseId) {
        delete updatedDetailsObject[action.courseId];

        if (newWebGatewayCourses && newWebGatewayCourses.length) {
            newWebGatewayCourses = newWebGatewayCourses.filter((item) => {
                return item.courseId !== action.courseId;
            });
        }

        if (newFavorite && newFavorite.length) {
            newFavorite = newFavorite.filter((item) => {
                return item.courseId !== action.courseId;
            });
        }

        if (newNearbyCourses && newNearbyCourses.length) {
            newNearbyCourses = newNearbyCourses.filter((item) => {
                return item.courseId !== action.courseId;
            });
        }
    }

    return {
        ...state,
        details: {
            ...updatedDetailsObject
        },
        webGatewayCourses: newWebGatewayCourses, // deleted item should be removed from the owened courses list - if not in list it will set the state list
        favorite: newFavorite, // deleted item should be removed from the favorite courses list - if not in list it will set the state list
        nearbyCourses: newNearbyCourses, // deleted item should be removed from the nearby courses list - if not in list it will set the state list
        deleteCourseInProgress: INITIAL_STATE.deleteCourseInProgress,
        deleteCourseError: INITIAL_STATE.deleteCourseError
    };
};

const deleteCourseError = (state) => {
    return {
        ...state,
        deleteCourseInProgress: INITIAL_STATE.deleteCourseInProgress,
        deleteCourseError: true
    };
};

const resetDeleteCourseErrorStatus = (state) => {
    return {
        ...state,
        deleteCourseError: INITIAL_STATE.deleteCourseInProgress
    };
};

const resetEditableCourseDataObject = (state) => {
    return {
        ...state,
        editableCourseData: { ...INITIAL_STATE.editableCourseData },
        courseRouteHistory: { ...INITIAL_STATE.courseRouteHistory },
        courseRouteHistoryIndex: 0
    };
};

const deleteAllCoursePointRestsObject = (state) => {
    const newCoursePoints = state?.editableCourseData?.coursePoints?.map((point) => {
        return {
            ...point,
            restDuration: null
        };
    });

    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            coursePoints: newCoursePoints
        }
    };
};

const deleteAllCoursePointCutoffsObject = (state) => {
    const newCoursePoints = state?.editableCourseData?.coursePoints?.map((point) => {
        return {
            ...point,
            cutoffDuration: null
        };
    });

    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            cutoffDuration: null,
            coursePoints: newCoursePoints
        }
    };
};

const deleteAllCoursePointNotesObject = (state) => {
    const newCoursePoints = state?.editableCourseData?.coursePoints?.map((point) => {
        return {
            ...point,
            note: null
        };
    });

    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            startNote: null,
            finishNote: null,
            coursePoints: newCoursePoints
        }
    };
};

const resetEditableCourseDataObjectOnDrawingMethodChanged = (state) => {
    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            geoPoints: INITIAL_STATE.editableCourseData.geoPoints,
            courseLines: INITIAL_STATE.editableCourseData.courseLines,
            coursePoints: INITIAL_STATE.editableCourseData.coursePoints,
            startPoint: INITIAL_STATE.editableCourseData.startPoint,
            boundingBox: INITIAL_STATE.editableCourseData.boundingBox,
            distanceMeter: INITIAL_STATE.editableCourseData.distanceMeter,
            elevationGainMeter: INITIAL_STATE.editableCourseData.elevationGainMeter,
            elevationLossMeter: INITIAL_STATE.editableCourseData.elevationLossMeter
        },
        courseRouteHistory: { ...INITIAL_STATE.courseRouteHistory },
        courseRouteHistoryIndex: 0
    };
};

const resetEditableCourseDrawingDataObject = (state) => {
    return {
        ...state,
        editableCourseDrawingData: {
            ...INITIAL_STATE.editableCourseDrawingData
        }
    };
};
/**
 * remove import from china fields since changes has applyed
 * @param {any} newEditableCourseObject
 * @returns
 */
function cleanUpImportedFieldsForChina(newEditableCourseData) {
    if (!newEditableCourseData._importFromChina) {
        return newEditableCourseData;
    }
    /** remove cached source data points */
    newEditableCourseData._importFromChina = undefined;
    newEditableCourseData._sourceGeoPoints = undefined;
    newEditableCourseData._sourceCoursePoints = undefined;
    newEditableCourseData._sourceCourseLines = undefined;
    newEditableCourseData.coordinateSystem = getCoordinateSystem();
    return newEditableCourseData;
}
const addEditableCourseDataObject = (state, action) => {
    let newEditableCourseObject = {
        ...state.editableCourseData,
        ...action.editableCourseData
    };

    let wereCoursePointsChanged = Object.keys(action.editableCourseData).filter((item) => {
        return item.indexOf('coursePoints') !== -1;
    });
    let wereGeoPointsChanged = Object.keys(action.editableCourseData).filter((item) => {
        return item.indexOf('geoPoints') !== -1;
    });
    let wereCourseLinesChanged = Object.keys(action.editableCourseData).filter((item) => {
        return item.indexOf('courseLines') !== -1;
    });
    let nextIndex = state.courseRouteHistoryIndex;
    let historyChanges = null;

    if (
        (wereGeoPointsChanged && wereGeoPointsChanged.length > 0) ||
        (wereCourseLinesChanged && wereCourseLinesChanged.length > 0) ||
        (wereCoursePointsChanged && wereCoursePointsChanged.length > 0)
    ) {
        let geoPoints =
            wereGeoPointsChanged && wereGeoPointsChanged.length > 0
                ? action.editableCourseData.geoPoints
                : state.editableCourseData.geoPoints;

        let courseMarkerPoints =
            wereCoursePointsChanged && wereCoursePointsChanged.length > 0
                ? action.editableCourseData.coursePoints
                : state.editableCourseData.coursePoints;

        let courseLinesChanged =
            wereCourseLinesChanged && wereCourseLinesChanged.length > 0
                ? action.editableCourseData.courseLines.sort((a, b) => a.sortOrder - b.sortOrder)
                : state.editableCourseData.courseLines;

        //if the course lines were changed then calculate the geoPoints - geoPoints can also be set individually(mostly the first point on new course)
        if (wereCourseLinesChanged && wereCourseLinesChanged.length > 0) {
            courseLinesChanged = updateLinesDataWithDistanceForEachPoint(
                courseLinesChanged,
                action.keepGeoPointsDistance
            );
            //allow overwriting of the geoPoints even if the value returned is an empty array - it could be to delete the last line
            geoPoints = getGeoPointsFromCourseSegmentLines(courseLinesChanged);
            // keep the start marker when deleting the last line
            if (!action.editableCourseData.courseLines.length && state.editableCourseData.geoPoints.length > 1) {
                geoPoints = [state.editableCourseData.geoPoints[0]];
            }
            /**
             * most of the time course lines change the distance of points change - get the marker corresponding point and sync the distance of the point marker
             */
            courseMarkerPoints = updateCourseMarkersDistanceBasedOnLines(
                courseLinesChanged,
                setStartFinishCoursePoints({ ...newEditableCourseObject, coursePoints: courseMarkerPoints }, geoPoints)
            );

            // add/remove LBCP points based on redux state, this needs done up here so they are available to push into
            // the historic list for Undo/Redo operations to work correctly, don't recalculate if course point was just moved
            if (!state?.coursePointMarkerData?.tempWorkInProgressPoint && !action?.doNotUpdateLBCP) {
                newEditableCourseObject = updateLapByCoursePoints(
                    {
                        ...newEditableCourseObject,
                        coursePoints: courseMarkerPoints
                    },
                    state.lapByCoursePointsEnabled
                );

                courseMarkerPoints = newEditableCourseObject?.coursePoints;
            }
        }

        let updatedDataFromGeoPoints = getPointsChangedObject(geoPoints);

        if (typeof action.historyOverwriteIndex === 'number' && action.historyOverwriteIndex >= 0) {
            //value of historyOverwriteIndex can be a number including 0
            nextIndex = action.historyOverwriteIndex;
        } else {
            nextIndex = ++nextIndex;
        }

        // any modifications that need to be picked up by Undo/Redo operations must be done above here or the changes
        // can get lost when undoing/redoing
        historyChanges = {
            ...getNextCourseRouteHistory(
                nextIndex,
                state.courseRouteHistory,
                updatedDataFromGeoPoints,
                courseMarkerPoints,
                courseLinesChanged
            )
        };

        if (
            (wereGeoPointsChanged && wereGeoPointsChanged.length > 0) ||
            (wereCourseLinesChanged && wereCourseLinesChanged.length > 0)
        ) {
            newEditableCourseObject = {
                ...newEditableCourseObject,
                ...updatedDataFromGeoPoints
            };
            if (courseMarkerPoints?.length > 0) {
                newEditableCourseObject.coursePoints = [...courseMarkerPoints];
            }
            if (action.historyOverwriteIndex !== 0) {
                newEditableCourseObject = cleanUpImportedFieldsForChina(newEditableCourseObject);
            }

            // Lap by Course Points need to be recalculated when the course polyline changes if the feature is enabled
            if (
                newEditableCourseObject?.geoPoints?.length > 0 &&
                !isLapByCoursePointsType(state.coursePointSelection.editModeMarkerInitialValue?.coursePointType) &&
                !state?.coursePointMarkerData?.tempWorkInProgressPoint && // don't recalculate if course point was just moved
                !action?.doNotUpdateLBCP
            ) {
                newEditableCourseObject = updateLapByCoursePoints(
                    newEditableCourseObject,
                    state.lapByCoursePointsEnabled
                );
            }
        }
    }

    return {
        ...state,
        editableCourseData: newEditableCourseObject,
        editableCourseDrawingData: {
            ...state.editableCourseDrawingData
        },
        courseRouteHistory: historyChanges
            ? {
                  ...historyChanges
              }
            : { ...state.courseRouteHistory },
        courseRouteHistoryIndex: historyChanges ? nextIndex : state.courseRouteHistoryIndex,
        lapByCoursePointsEnabled: courseHasLapByCoursePoints(newEditableCourseObject)
    };
};

const enableLapByCoursePoints = (state, action) => {
    return {
        ...state,
        lapByCoursePointsEnabled: action.lapByCoursePointsEnabled
    };
};

const addImportedCourseDataObject = (state, action) => {
    return {
        ...state,
        importedCourse: action.importedCourseData
    };
};

const resetImportedCourseDataObject = (state) => {
    return {
        ...state,
        importedCourse: INITIAL_STATE.importedCourse
    };
};

const addEditableCourseDrawingDataObject = (state, action) => {
    let newEditableCourseDrawingData = {
        ...state.editableCourseDrawingData,
        ...action.editableCourseDrawingData
    };
    return {
        ...state,
        editableCourseDrawingData: newEditableCourseDrawingData
    };
};

const receiveWebGatewayCourses = (state, action) => {
    //based on the endpoint called (for china its different) the response is a direct array or an object and the array is under coursesForUser
    return {
        ...state,
        webGatewayCourses: action.courses && action.courses.coursesForUser
    };
};

const receiveGroupCourses = (state, action) => {
    return {
        ...state,
        group: action.courses
    };
};

const receiveFavoriteCourses = (state, action) => {
    return {
        ...state,
        favorite: action.courses
    };
};

const receiveCourse = (state, action) => {
    const updatedCoursePoints = setStartFinishCoursePoints(action.course, action.course?.geoPoints);

    const newCourse = { ...action.course, coursePoints: updatedCoursePoints };
    return {
        ...state,
        details: {
            ...state.details,
            [action.course.courseId]: newCourse
        },
        fetchingCourseDetails: false,
        editableCourseData: {
            ...state.editableCourseData,
            coordinateSystem: getCoordinateSystem(action.course && action.course.fromImport),
            ...newCourse
        },
        lapByCoursePointsEnabled: courseHasLapByCoursePoints(action.course)
    };
};

const fetchedDuplicatedCourseData = (state, action) => {
    //in case the course lines are not set - like for 3rd party courses make sure to create the lines
    let courseLines =
        action.duplicatedCourseData &&
        action.duplicatedCourseData.courseLines &&
        action.duplicatedCourseData.courseLines.length
            ? action.duplicatedCourseData.courseLines
            : setCourseLines(
                  true,
                  action.duplicatedCourseData.geoPoints, // complete geopoints with received elevation
                  action.duplicatedCourseData
              );

    const updatedCoursePoints = setStartFinishCoursePoints(
        action?.duplicatedCourseData,
        action?.duplicatedCourseData?.geoPoints
    );
    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            ...action.duplicatedCourseData, // when we received the duplicated course data set it in the editable course data,
            courseName: i18next.t('course:course_copy_of_prefix', { 0: action.duplicatedCourseData.courseName }),
            courseLines: courseLines,
            coursePoints: updatedCoursePoints
        },
        courseRouteHistory: {
            ...getNextCourseRouteHistory(
                state.courseRouteHistoryIndex, // in case this is the initial request - first display - this is the initial index value
                state.courseRouteHistory,
                action.duplicatedCourseData,
                state.editableCourseData.coursePoints,
                courseLines
            )
        },
        courseDuplicateFetching: false,
        lapByCoursePointsEnabled: courseHasLapByCoursePoints(action.duplicatedCourseData)
    };
};

const onFetchCourseDuplicateDataStartOrEnd = (isStart) => (state) => {
    return {
        ...state,
        courseDuplicateFetching: isStart
    };
};

const fetchCourseDetailsStart = (state, action) => {
    return {
        ...state,
        fetchingCourseDetails: true
    };
};

const confirmElevationWasUpdatedByApi = (state) => {
    let newEditableCourseData = { ...state.editableCourseData };

    if (newEditableCourseData.elevationDataUpdated) {
        delete newEditableCourseData.elevationDataUpdated;
    }

    return {
        ...state,
        editableCourseData: {
            ...newEditableCourseData
        }
    };
};

const receiveCourseFail = (state, action) => {
    return {
        ...state,
        fetchingCourseDetails: false
    };
};

const onReceiveCourseLinesSegments = (state, action) => {
    //must handle courseRouteHistory on receive course lines because if the user goes on to edit and adds points we need to have the initial value
    const nextIndex = ++state.courseRouteHistoryIndex;
    const initialObjectForHistoryFromCourseData = getInitialObjectForHistoryFromCourseData(state.editableCourseData);
    //if received lines from the API are 0 then we set them on the front end - like in the case of 3rd party courses that might not have lines
    let courseLines =
        action.courseLines && action.courseLines.length
            ? action.courseLines
            : setCourseLines(
                  true,
                  state.editableCourseData.geoPoints, // complete geopoints with received elevation
                  state.editableCourseData
              );

    /**
     * this is used to set the maker identifier on the course point - so when changing a line it will take the marker into account
     * the marker id's should be set on the course lines, but in the scenario that the course lines are an empty array make sure to add them
     */
    if (!action.courseLines || action.courseLines.length === 0) {
        // in this case the course points were created from the available geoPoints
        courseLines = setPointMarkerIdInCoursePoint(courseLines, state.editableCourseData.coursePoints);
    }
    /**
     * on course line received set the geoPoints according to the lines - this should keep consistency between the two
     * also the history is set here - not needed in courseFetch since only course lines are in edit mode where history is available
     */
    let geoPointsFromLine = getGeoPointsFromCourseSegmentLines(courseLines);

    initialObjectForHistoryFromCourseData.geoPoints = geoPointsFromLine;

    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            courseLines: courseLines,
            geoPoints: geoPointsFromLine
        },
        initialCourseDataWithNoChanges: {
            ...state.editableCourseData,
            courseLines: courseLines,
            geoPoints: geoPointsFromLine
        },
        courseRouteHistory: {
            ...getNextCourseRouteHistory(
                nextIndex,
                state.courseRouteHistory,
                initialObjectForHistoryFromCourseData,
                state.editableCourseData.coursePoints,
                courseLines
            )
        },
        courseRouteHistoryIndex: nextIndex,
        courseLinesFetching: INITIAL_STATE.courseLinesFetching
    };
};

const onFetchCourseLinesSegmentsStart = (state, action) => {
    return {
        ...state,
        courseLinesFetching: true
    };
};

const fetchStartMapRoute = (state, action) => {
    return {
        ...state,
        editableCourseDrawingData: {
            ...state.editableCourseDrawingData,
            mapRouteFetching: true
        }
    };
};

const receiveCourseRoutePoints = (state, action) => {
    // the state updated was extracted to a new function to prevent duplicated code with receiveCourseRoutePointsWithClimb function
    return getCourseRouteReceiveStateWithUpdatedHistory(state, action, action.geoPoints);
};

const createNewCourseSuccess = (state, action) => {
    let data = action.newCourseData;

    return {
        ...state,
        editableCourseDrawingData: {
            ...state.editableCourseDrawingData,
            createNewCourseId: data.courseId,
            inlineMode: action.inlineMode
        }
    };
};

const createNewCourseError = (state) => {
    return {
        ...state,
        editableCourseDrawingData: {
            ...state.editableCourseDrawingData,
            createNewCourseId: null
        }
    };
};

const errorOnReceiveCourseRoute = (state, action) => {
    return {
        ...state,
        editableCourseDrawingData: {
            ...state.editableCourseDrawingData,
            mapRouteFetching: false,
            receivedRouteDoesNotHaveData: true
        }
    };
};

const onFetchElevationDataForCoursePointsStartOrEnd = (isStart) => (state) => {
    return {
        ...state,
        courseElevationFetching: isStart
    };
};

//on receiving the course points with elevation
const onFetchElevationDataForCoursePointsSuccess = (state, action) => {
    //implementation similar to onSuccess in GarminElevationService - were getElevationByLatLng is called to set the elevation for each point
    const dataWithElevation = setElevationIntoGeoPointsObject(
        state.editableCourseData.geoPoints,
        action.geoPointsWithElevation
    );

    const updatedDataFromGeoPoints = getPointsChangedObject(dataWithElevation, action.undo);

    const courseLines = updateExistingCourseLinesWithElevation(
        state.editableCourseData.courseLines,
        updatedDataFromGeoPoints.geoPoints
    );

    const updatedCoursePoints = setStartFinishCoursePoints(
        state.editableCourseData,
        updatedDataFromGeoPoints?.geoPoints,
        action.undo
    );

    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            ...updatedDataFromGeoPoints,
            courseLines: courseLines,
            coursePoints: updatedCoursePoints
        },
        courseElevationFetching: false,
        courseRouteHistory: {
            ...getNextCourseRouteHistory(
                state.courseRouteHistoryIndex, // on elevation fetch the index is not incremented because this request is dependent on the previous fetch points
                state.courseRouteHistory,
                updatedDataFromGeoPoints,
                updatedCoursePoints,
                courseLines,
                false, // prevents filtering out the history for redo when only the elevation data is updated
                action.undo
            )
        }
    };
};

const changingFavoriteCourseStatusStart = (state, action) => {
    return {
        ...state,
        isSettingFavoriteCourseInProgress: true,
        changingFavoriteCourseStatusFail: false
    };
};

const setTheFavoriteCourseStatus = (isFavorite) => (state, action) => {
    let details = {};

    //update the favorite status for the course based on the id also for the single editableCourseData
    let newWebGatewayCourses =
        state.webGatewayCourses && state.webGatewayCourses.length
            ? [...state.webGatewayCourses]
            : state.webGatewayCourses;
    let newFavorite = state.favorite && state.favorite.length ? [...state.favorite] : state.favorite;
    let newNearbyCourses =
        state.nearbyCourses && state.nearbyCourses.length ? [...state.nearbyCourses] : state.nearbyCourses;

    if (action && action.courseId) {
        details = {
            ...state.details,
            [action.courseId]: {
                ...state.details[action.courseId],
                favorite: isFavorite
            }
        };
        let foundCourseWithChangedFavoriteStatus;
        //also update in the list of courseDetails based on the id - the editableCourseData is handled on reset
        if (newWebGatewayCourses && newWebGatewayCourses.length) {
            let foundItem = newWebGatewayCourses.find((item) => {
                return item.courseId === action.courseId;
            });

            if (foundItem) {
                foundItem.favorite = isFavorite;
                //set the favorite course to be added in the favorites tab
                foundCourseWithChangedFavoriteStatus = { ...foundItem };
            }
        }

        if (newNearbyCourses && newNearbyCourses.length) {
            let foundItem = newNearbyCourses.find((item) => {
                return item.courseId === action.courseId;
            });

            if (foundItem) {
                foundItem.favorite = isFavorite;
                //set the favorite course to be added in the favorites tab
                foundCourseWithChangedFavoriteStatus = { ...foundItem };
            }
        }

        if (isFavorite && foundCourseWithChangedFavoriteStatus) {
            //add to favorites
            newFavorite.push(foundCourseWithChangedFavoriteStatus);
        } else {
            //removed from favorites
            if (newFavorite && newFavorite.length) {
                newFavorite = newFavorite.filter((item) => {
                    return item.courseId !== action.courseId;
                });
            }
        }
    }

    return {
        ...state,
        details: {
            ...state.details,
            ...details
        },
        editableCourseData: {
            ...state.editableCourseData,
            favorite: isFavorite
        },
        webGatewayCourses: newWebGatewayCourses, // deleted item should be removed from the owened courses list - if not in list it will set the state list
        favorite: newFavorite, // deleted item should be removed from the favorite courses list - if not in list it will set the state list
        nearbyCourses: newNearbyCourses, // deleted item should be removed from the nearby courses list - if not in list it will set the state list
        isSettingFavoriteCourseInProgress: false,
        changingFavoriteCourseStatusFail: false
    };
};

const settingFavoriteCourseStatusError = (state, action) => {
    return {
        ...state,
        isSettingFavoriteCourseInProgress: false,
        changingFavoriteCourseStatusFail: true
    };
};

const updateCoursePrivacySuccess = (state, action) => {
    const { privacyRule, courseId } = action;
    const isPublic = privacyRule.typeId === RulesDTO.public.id;

    return {
        ...state,
        webGatewayCourses: state.webGatewayCourses.map((course) => {
            if (course.courseId === courseId) {
                return { ...course, public: isPublic, privacyRule };
            }
            return course;
        }),
        favorite: state.favorite.map((course) => {
            if (course.courseId === courseId) {
                return { ...course, public: isPublic, privacyRule };
            }
            return course;
        })
    };
};

const resetChangingFavoriteCourseStatusFail = (state, action) => {
    return {
        ...state,
        changingFavoriteCourseStatusFail: INITIAL_STATE.changingFavoriteCourseStatusFail
    };
};

const setCourseElevationChartExpandedStatus = (state, action) => {
    const status = action.status;

    return {
        ...state,
        elevationChart: {
            ...state.elevationChart,
            courseElevationChartExpandedStatus: status
        }
    };
};

const setChartSelectedAreaStartEndValue = (state, action) => {
    const selectionStart = action.selectionStart;
    const selectionEnd = action.selectionEnd;

    //selectionStart and selectionEnd must always be set because in some cases it will be reset to null intentionally
    return {
        ...state,
        elevationChart: {
            ...state.elevationChart,
            selectionStart: selectionStart,
            selectionEnd: selectionEnd
        }
    };
};

const resetCourseElevationChartExpandedStatus = (state) => {
    return {
        ...state,
        elevationChart: {
            ...state.elevationChart,
            courseElevationChartExpandedStatus: INITIAL_STATE.elevationChart.courseElevationChartExpandedStatus
        }
    };
};

const resetChartSelectedAreaStartEndValue = (state) => {
    return {
        ...state,
        elevationChart: {
            ...state.elevationChart,
            selectionEnd: INITIAL_STATE.elevationChart.courseElevationChartExpandedStatus,
            selectionStart: INITIAL_STATE.elevationChart.courseElevationChartExpandedStatus
        }
    };
};

const setElevationChartSelectedGeoPoints = (state, action) => {
    return {
        ...state,
        elevationChart: {
            ...state.elevationChart,
            selectedGeoPoints: action.selectedGeoPoints
        }
    };
};

const onReceivedAvailableCoursePoints = (state, action) => {
    return {
        ...state,
        availableCoursePoints: action.availableCoursePoints
    };
};

const setCoursePointSelection = (state, action) => {
    let coursePointSelectionData = {
        ...state.coursePointSelection,
        ...action.payload
    };
    return {
        ...state,
        coursePointSelection: {
            ...coursePointSelectionData
        }
    };
};
const resetCoursePointSelection = (state, action) => {
    return {
        ...state,
        coursePointSelection: INITIAL_STATE.coursePointSelection
    };
};

const onElevationChartHover = (state, action) => {
    return {
        ...state,
        elevationChartHoverValue: action.payload
    };
};

const resetElevationChartHover = (state) => {
    return {
        ...state,
        elevationChartHoverValue: INITIAL_STATE.elevationChartHoverValue
    };
};

const resetElevationChartSelectedGeoPoints = (state) => {
    return {
        ...state,
        elevationChart: {
            ...state.elevationChart,
            selectedGeoPoints: INITIAL_STATE.elevationChart.selectedGeoPoints
        }
    };
};

const onAlterCourseRouteHistory = (isRedo) => (state, action) => {
    let currentIndex;

    if (isRedo) {
        currentIndex = ++state.courseRouteHistoryIndex;
    } else {
        currentIndex = --state.courseRouteHistoryIndex;
    }

    const historicData = state.courseRouteHistory[currentIndex];

    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            ...historicData
        },
        courseRouteHistoryIndex: currentIndex,
        climbsOnRouteOrCourse: historicData.climbsOnRouteOrCourse,
        lapByCoursePointsEnabled: courseHasLapByCoursePoints(historicData)
    };
};

const setCoursePointMarkerData = (state, action) => {
    return {
        ...state,
        coursePointMarkerData: { ...state.coursePointMarkerData, ...action.payload }
    };
};

const resetCoursePointMarkerData = (state, action) => {
    return {
        ...state,
        coursePointMarkerData: INITIAL_STATE.coursePointMarkerData
    };
};

const requestNearbyCourses = (state, action) => {
    return {
        ...state,
        nearbyCoursesFetching: true
    };
};

const receiveNearbyCourses = (state, action) => {
    let newNearByCourses;

    if (action.fromCourseIndex && state.nearbyCourses && state.nearbyCourses.length) {
        //keep the old courses if
        newNearByCourses = [...state.nearbyCourses, ...action.nearbyCourses.courseSummaryDTOs];
    } else {
        newNearByCourses = action.nearbyCourses.courseSummaryDTOs;
    }

    return {
        ...state,
        nearbyCourses: newNearByCourses,
        nearbyCoursesTotalSearchHits: action.nearbyCourses.totalSearchHits,
        nearbyCoursesFetching: false,
        boundingBoxError: false
    };
};

const resetNearbyCourses = (state, action) => {
    return {
        ...state,
        nearbyCourses: INITIAL_STATE.nearbyCourses,
        nearbyCoursesTotalSearchHits: INITIAL_STATE.nearbyCoursesTotalSearchHits,
        nearbyCoursesFetching: false,
        boundingBoxError: true
    };
};

const setConsumers = (state, action) => {
    return {
        ...state,
        consumers: {
            ...state.consumers,
            [action.courseId]: action.consumerInfo
        }
    };
};

const resetCoursesListSort = (state) => {
    return {
        ...state,
        courseListSortType: INITIAL_STATE.courseListSortType
    };
};

const setCoursesListSortSuccess = (state, action) => {
    return {
        ...state,
        courseListSortType: action.courseListSortType
    };
};

const setCoursesListFilters = (state, action) => {
    return {
        ...state,
        courseListFilters: action.courseListFilters
    };
};

const resetCoursesListFilters = (state) => {
    return {
        ...state,
        courseListFilters: INITIAL_STATE.courseListFilters
    };
};

const setMapBoundingBox = (state, action) => {
    return {
        ...state,
        mapBoundingBox: action.mapBoundingBox
    };
};

const resetMapBoundingBox = (state) => {
    return {
        ...state,
        mapBoundingBox: INITIAL_STATE.mapBoundingBox
    };
};

const fetchGeoPointsForCoursesStart = (state, action) => {
    return {
        ...state,
        coursesListGeoPoints: {
            ...state.coursesListGeoPoints,
            fetching: action.courseIds
        }
    };
};

const fetchGeoPointsForCoursesSuccess = (state, action) => {
    return {
        ...state,
        coursesListGeoPoints: {
            items: {
                ...state.coursesListGeoPoints.items,
                ...action.coursesListGeoPoints
            },
            fetching: false
        }
    };
};

const fetchGeoPointsForCoursesError = (state) => {
    return {
        ...state,
        coursesListGeoPoints: {
            ...state.coursesListGeoPoints,
            fetching: false
        }
    };
};

const removeCachedMinimapRouteByIds = (state, action) => {
    let newItems = {
        ...state.coursesListGeoPoints.items
    };

    if (action && action.courseIds && action.courseIds.length) {
        action.courseIds.forEach((id) => {
            if (newItems[id]) {
                delete newItems[id];
            }
        });
    }

    return {
        ...state,
        coursesListGeoPoints: {
            ...state.coursesListGeoPoints,
            items: { ...newItems }
        }
    };
};

const resetGeoPointsForCoursesList = (state) => {
    return {
        ...state,
        coursesListGeoPoints: INITIAL_STATE.coursesListGeoPoints
    };
};

const requestClimbs = (state) => {
    return {
        ...state,
        climbsListFetching: true
    };
};

const receiveClimbs = (state, action) => {
    let newCachedClimbs = state.cachedClimbs
        ? {
              ...state.cachedClimbs
          }
        : {};

    if (action.climbs && action.climbs.length) {
        action.climbs.forEach((climb) => {
            if (climb && climb.primaryClimbs && climb.primaryClimbs.length) {
                newCachedClimbs[climb.primaryClimbs[0].gmapClimbId] = { ...climb };
            }
        });
    }

    return {
        ...state,
        climbsListFetching: false,
        climbs: action.climbs,
        cachedClimbs: newCachedClimbs
    };
};

const receiveClimbsFailed = (state) => {
    return {
        ...state,
        climbsListFetching: false
    };
};

const resetCachedClimbs = (state) => {
    return {
        ...state,
        cachedClimbs: INITIAL_STATE.cachedClimbs,
        climbsListFetching: false
    };
};

const requestClimbsOnRoute = (state) => {
    return {
        ...state,
        climbsOnRouteFetching: true
    };
};

const receiveClimbsOnRoute = (state, action) => {
    const historyUpdateObject =
        action.historyIndex >= 0
            ? {
                  courseRouteHistory: {
                      ...updateCourseRouteHistoryWithWithClimbsOnRoute(
                          action.historyIndex,
                          state.courseRouteHistory,
                          action.climbsOnRouteOrCourse
                      )
                  }
              }
            : {};

    return {
        ...state,
        ...historyUpdateObject,
        climbsOnRouteFetching: false,
        climbsOnRouteOrCourse: action.climbsOnRouteOrCourse
    };
};

const requestClimbsOnCourse = (state) => {
    return {
        ...state,
        climbsOnCourseFetching: true
    };
};

const receiveClimbsOnCourse = (state, action) => {
    return {
        ...state,
        climbsOnCourseFetching: false,
        courseRouteHistory: {
            ...updateCourseRouteHistoryWithWithClimbsOnRoute(1, state.courseRouteHistory, action.climbsOnRouteOrCourse)
        },
        climbsOnRouteOrCourse: action.climbsOnRouteOrCourse
    };
};

const requestSecondaryClimbs = (state) => {
    return {
        ...state,
        secondaryClimbsFetching: true
    };
};

const receiveSecondaryClimbs = (state, action) => {
    return {
        ...state,
        secondaryClimbsFetching: false,
        secondaryClimbs: action.secondaryClimbs
    };
};

const resetSecondaryClimbs = (state, action) => {
    return {
        ...state,
        secondaryClimbs: INITIAL_STATE.secondaryClimbs
    };
};

const resetClimbsOnRouteOrCourse = (state, action) => {
    return {
        ...state,
        climbsOnRouteOrCourse: INITIAL_STATE.climbsOnRouteOrCourse
    };
};

const receiveCourseRoutePointsWithClimb = (state, action) => {
    let geoPoints = action.geoPoints;

    const climbGeoPoints = action.climb.map((point) => {
        return [[point.latitude, point.longitude]];
    });

    const mergeGeoPoints = action.addClimbOnly ? climbGeoPoints : [...geoPoints, ...climbGeoPoints];

    return getCourseRouteReceiveStateWithUpdatedHistory(state, action, mergeGeoPoints);
};

const getCourseRouteReceiveStateWithUpdatedHistory = (state, action, geoPoints) => {
    /**
     * there has been a request to remove the start point location - CA-137114 - because it is usually not  set on the road
     * so we do not send the initial point to be added in the processed data
     * if we want the initial point added back send the extra param eg: previousSetPoints.length > 0
     */
    let currentPoints =
        state.editableCourseData.geoPoints && state.editableCourseData.geoPoints.length > 1
            ? state.editableCourseData.geoPoints
            : false;

    let processedData, courseLines;

    if (action.addToExistingPoints) {
        processedData = getProcessedDataFromGeoPoints(geoPoints, structuredClone(currentPoints)); // use copy of currentPoints so we don't update original array
        let newProcessedGeoPoints = processedData.geoPoints.slice(currentPoints.length - 1);
        courseLines = setCourseLines(false, newProcessedGeoPoints, state.editableCourseData);
    } else {
        // in case the automatic course creation we don't need the previous courseLines and points
        processedData = getProcessedDataFromGeoPoints(geoPoints, false);
        courseLines = setCourseLines(false, processedData.geoPoints, {
            courseId: state.editableCourseData.courseId,
            courseLines: []
        });
    }

    //on receiving the course points increment the courseRouteHistoryIndex
    let nextIndex = state.courseRouteHistoryIndex;
    let tempCourseRouteHistory = { ...state.courseRouteHistory };
    //if actually received points and not an empty response from the API
    if (action.geoPoints && action.geoPoints.length > 0) {
        nextIndex = ++nextIndex;
        tempCourseRouteHistory = {
            ...getNextCourseRouteHistory(
                nextIndex,
                state.courseRouteHistory,
                processedData, // getProcessedDataFromGeoPoints uses getPointsChangedObject to return the same object, so it should behave the same way - it just processes extra raw data
                state.editableCourseData.coursePoints,
                courseLines
            )
        };
    }

    let newEditableCourseData = {
        ...state.editableCourseData,
        ...processedData,
        courseLines: courseLines
    };

    newEditableCourseData = cleanUpImportedFieldsForChina(newEditableCourseData);

    // Lap by Course Points need to be recalculated when the course polyline changes if the feature is enabled
    if (newEditableCourseData?.geoPoints?.length > 0) {
        newEditableCourseData = updateLapByCoursePoints(newEditableCourseData, state.lapByCoursePointsEnabled);
    }

    return {
        ...state,
        editableCourseData: newEditableCourseData,
        courseRouteHistory: tempCourseRouteHistory,
        courseRouteHistoryIndex: nextIndex,
        editableCourseDrawingData: {
            ...state.editableCourseDrawingData,
            mapRouteFetching: false,
            receivedRouteDoesNotHaveData: action.geoPoints.length === 0
        }
    };
};

const requestCourseMapMatch = (state, action) => {
    return {
        ...state,
        mapMatchState: {
            courseId: action.courseId,
            processing: true,
            error: false
        }
    };
};

const requestCourseMapMatchDone = (state, action) => {
    return {
        ...state,
        mapMatchState: {
            courseId: null,
            processing: false,
            error: action.error
        }
    };
};

const resetCourseMapMatchStatus = (state, action) => {
    return {
        ...state,
        mapMatchState: {
            courseId: null,
            processing: false,
            error: false
        }
    };
};

const requestHazards = (state) => {
    return {
        ...state,
        hazardsFetching: true
    };
};

const receiveHazards = (state, action) => {
    return {
        ...state,
        hazardsFetching: false,
        hazards: action.hazards
    };
};

const receiveHazardsFailed = (state) => {
    return {
        ...state,
        hazardsFetching: false
    };
};

const requestHazardsOnCourse = (state) => {
    return {
        ...state,
        hazardsFetching: true
    };
};

const resetHazardsArray = (state) => {
    return {
        ...state,
        hazards: INITIAL_STATE.hazards
    };
};

/**
 * update data point elevation on china import initializing
 */
function updateElevationOnChinaImport(state, action) {
    if (!state.editableCourseData._importFromChina) {
        return state;
    }
    //implementation similar to onSuccess in GarminElevationService - were getElevationByLatLng is called to set the elevation for each point
    const dataWithElevation = setElevationIntoGeoPointsObject(
        state.editableCourseData._sourceGeoPoints,
        action.geoPointsWithElevation
    );
    const updatedDataFromGeoPoints = getPointsChangedObject(dataWithElevation);

    const courseLines = updateExistingCourseLinesWithElevation(
        state.editableCourseData._sourceCourseLines,
        updatedDataFromGeoPoints.geoPoints
    );

    const updatedCoursePoints = setStartFinishCoursePoints(
        { coursePoints: state.editableCourseData._sourceCoursePoints },
        updatedDataFromGeoPoints?.geoPoints
    );

    return {
        ...state,
        editableCourseData: {
            ...state.editableCourseData,
            _sourceGeoPoints: updatedDataFromGeoPoints.geoPoints,
            _sourceCourseLines: courseLines,
            _sourceCoursePoints: updatedCoursePoints
        }
    };
}

const handlers = {
    [REQUEST_COURSES]: requestCourses,
    [RECEIVE_COURSES]: receiveCourses,
    [DELETE_COURSE_START]: deleteCourseStart,
    [DELETE_COURSE_SUCCESS]: deleteCourseSuccess,
    [DELETE_COURSE_ERROR]: deleteCourseError,
    [RESET_DELETE_COURSE_ERROR_STATUS]: resetDeleteCourseErrorStatus,
    [RECEIVE_WEB_GATEWAY_COURSES]: receiveWebGatewayCourses,
    [RECEIVE_WEB_GATEWAY_COURSES_FOR_CHINA]: receiveWebGatewayCourses,
    [REQUEST_GROUP_COURSES]: requestCourses,
    [RECEIVE_GROUP_COURSES]: receiveGroupCourses,
    [FETCH_FAVORITE_COURSES_SUCCESS]: receiveFavoriteCourses,
    [FETCH_FAVORITE_COURSES_FAIL]: receiveFavoriteCourses,
    [FETCH_COURSE_DETAILS_START]: fetchCourseDetailsStart,
    [FETCH_COURSE_DETAIL_SUCCESS]: receiveCourse,
    [FETCH_COURSE_DETAIL_FAIL]: receiveCourseFail,
    [GET_COURSE_ROUTE_SEGMENT]: onFetchCourseLinesSegmentsStart,
    [GET_COURSE_ROUTE_SEGMENT_ERROR]: onReceiveCourseLinesSegments, // on error the course lines will be created by the client - course lines are mandatory
    [GET_COURSE_ROUTE_SEGMENT_SUCCESS]: onReceiveCourseLinesSegments,
    [RESET_EDITABLE_COURSE_DATA]: resetEditableCourseDataObject,
    [RESET_EDITABLE_COURSE_DATA_ON_DRAWING_METHOD_CHANGED]: resetEditableCourseDataObjectOnDrawingMethodChanged,
    [RESET_EDITABLE_COURSE_DRAWING_DATA]: resetEditableCourseDrawingDataObject,
    [DELETE_COURSE_POINTS_RESTS]: deleteAllCoursePointRestsObject,
    [DELETE_COURSE_POINTS_CUTOFFS]: deleteAllCoursePointCutoffsObject,
    [DELETE_COURSE_POINTS_NOTES]: deleteAllCoursePointNotesObject,
    [ADD_EDITABLE_COURSE_DATA]: addEditableCourseDataObject,
    [ADD_IMPORTED_COURSE_DATA]: addImportedCourseDataObject,
    [RESET_IMPORTED_COURSE_DATA]: resetImportedCourseDataObject,
    [ADD_EDITABLE_COURSE_DRAWING_DATA]: addEditableCourseDrawingDataObject,
    [FETCH_START_COURSE_ROUND_TRIP_ROUTE]: fetchStartMapRoute,
    [FETCH_START_COURSE_POPULAR_ROUTES]: fetchStartMapRoute,
    [RECEIVE_COURSE_ROUND_TRIP_ROUTE]: receiveCourseRoutePoints,
    [CREATE_NEW_COURSE_SUCCESS]: createNewCourseSuccess,
    [CREATE_NEW_COURSE_ERROR]: createNewCourseError,
    [UPDATE_COURSE_DATA_SUCCESS]: createNewCourseSuccess, //updating a course behaves similar to creating a new one
    [UPDATE_COURSE_DATA_ERROR]: createNewCourseError, //error when updating a course behaves similar to creating a new one
    [RECEIVE_COURSE_ROUND_TRIP_ROUTE_ERROR]: errorOnReceiveCourseRoute,
    [FETCH_COURSE_POPULAR_ROUTES_ERROR]: errorOnReceiveCourseRoute,
    [FETCH_COURSE_POPULAR_ROUTES_SUCCESS]: receiveCourseRoutePoints,
    [FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_START]: onFetchElevationDataForCoursePointsStartOrEnd(true),
    [FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ENDED]: onFetchElevationDataForCoursePointsStartOrEnd(false),
    [FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ERROR]: onFetchElevationDataForCoursePointsStartOrEnd(false),
    [FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_SUCCESS]: onFetchElevationDataForCoursePointsSuccess,
    [SET_COURSE_TO_FAVORITE]: changingFavoriteCourseStatusStart,
    [SET_COURSE_TO_FAVORITE_SUCCESS]: setTheFavoriteCourseStatus(true),
    [SET_COURSE_TO_FAVORITE_FAIL]: settingFavoriteCourseStatusError,
    [REMOVE_COURSE_FROM_FAVORITE]: changingFavoriteCourseStatusStart,
    [REMOVE_COURSE_FROM_FAVORITE_SUCCESS]: setTheFavoriteCourseStatus(false),
    [REMOVE_COURSE_FROM_FAVORITE_FAIL]: settingFavoriteCourseStatusError,
    [UPDATE_COURSE_PRIVACY_SUCCESS]: updateCoursePrivacySuccess,
    [RESET_CHANGING_FAVORITE_COURSE_STATUS_FAIL]: resetChangingFavoriteCourseStatusFail,
    [UNDO_COURSE_ROUTE_HISTORY]: onAlterCourseRouteHistory(false),
    [REDO_COURSE_ROUTE_HISTORY]: onAlterCourseRouteHistory(true),
    [SET_COURSE_ELEVATION_CHART_EXPANDED_STATUS]: setCourseElevationChartExpandedStatus,
    [RESET_COURSE_ELEVATION_CHART_EXPANDED_STATUS]: resetCourseElevationChartExpandedStatus,
    [SET_CHART_SELECTED_AREA_START_END_VALUE]: setChartSelectedAreaStartEndValue,
    [RESET_CHART_SELECTED_AREA_START_END_VALUE]: resetChartSelectedAreaStartEndValue,
    [SET_ELEVATION_CHART_SELECTED_GEO_POINTS]: setElevationChartSelectedGeoPoints,
    [RESET_ELEVATION_CHART_SELECTED_GEO_POINTS]: resetElevationChartSelectedGeoPoints,
    [FETCH_COURSE_POINTS_SUCCESS]: onReceivedAvailableCoursePoints,
    [SET_COURSE_POINT_SELECTION]: setCoursePointSelection,
    [RESET_COURSE_POINT_SELECTION]: resetCoursePointSelection,
    [ELEVATION_CHART_HOVER]: onElevationChartHover,
    [RESET_ELEVATION_CHART_HOVER]: resetElevationChartHover,
    [SET_COURSE_MARKER_DATA]: setCoursePointMarkerData,
    [RESET_COURSE_MARKER_DATA]: resetCoursePointMarkerData,
    [DUPLICATE_COURSE_SUCCESS]: fetchedDuplicatedCourseData,
    [DUPLICATE_COURSE_START]: onFetchCourseDuplicateDataStartOrEnd(true),
    [DUPLICATE_COURSE_ERROR]: onFetchCourseDuplicateDataStartOrEnd(false),
    [REQUEST_NEARBY_COURSES]: requestNearbyCourses,
    [FETCH_NEARBY_COURSES_SUCCESS]: receiveNearbyCourses,
    [FETCH_NEARBY_COURSES_ERROR]: receiveNearbyCourses,
    [RESET_NEARBY_COURSES]: resetNearbyCourses,
    [RECEIVE_THIRD_PARTY_CONSUMER_INFO]: setConsumers,
    [FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_START]: fetchGeoPointsForCoursesStart,
    [FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_SUCCESS]: fetchGeoPointsForCoursesSuccess,
    [FETCH_GEOPOINTS_FOR_COURSES_MINIMAP_ERROR]: fetchGeoPointsForCoursesError,
    [RESET_GEOPOINTS_FOR_COURSES_MINIMAP_LIST]: resetGeoPointsForCoursesList,
    [REMOVE_CACHED_MINIMAP_ROUTE_BY_IDS]: removeCachedMinimapRouteByIds,
    [RESET_COURSES_LIST_SORT_VALUE]: resetCoursesListSort,
    [SET_COURSES_LIST_SORT_VALUE]: setCoursesListSortSuccess,
    [SET_COURSES_LIST_FILTER_VALUE]: setCoursesListFilters,
    [RESET_COURSES_LIST_FILTER_VALUE]: resetCoursesListFilters,
    [SET_MAP_BOUNDING_BOX]: setMapBoundingBox,
    [RESET_MAP_BOUNDING_BOX]: resetMapBoundingBox,
    [CONFIRM_ELEVATION_WAS_UPDATED_BY_API_FOR_COURSE]: confirmElevationWasUpdatedByApi,
    [REQUEST_CLIMBS]: requestClimbs,
    [RECEIVE_CLIMBS]: receiveClimbs,
    [RECEIVE_CLIMBS_FAILED]: receiveClimbsFailed,
    [RESET_CACHED_CLIMBS]: resetCachedClimbs,
    [REQUEST_CLIMBS_ON_ROUTE]: requestClimbsOnRoute,
    [RECEIVE_CLIMBS_ON_ROUTE]: receiveClimbsOnRoute,
    [REQUEST_CLIMBS_ON_COURSE]: requestClimbsOnCourse,
    [RECEIVE_CLIMBS_ON_COURSE]: receiveClimbsOnCourse,
    [REQUEST_SECONDARY_CLIMBS]: requestSecondaryClimbs,
    [RECEIVE_SECONDARY_CLIMBS]: receiveSecondaryClimbs,
    [RESET_SECONDARY_CLIMBS]: resetSecondaryClimbs,
    [RESET_CLIMBS_ON_ROUTE_OR_COURSE]: resetClimbsOnRouteOrCourse,
    [FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_ERROR]: errorOnReceiveCourseRoute,
    [FETCH_COURSE_POPULAR_ROUTES_AND_ADD_CLIMB_SUCCESS]: receiveCourseRoutePointsWithClimb,
    [REQUEST_COURSE_MAP_MATCH]: requestCourseMapMatch,
    [REQUEST_COURSE_MAP_MATCH_DONE]: requestCourseMapMatchDone,
    [RESET_COURSE_MAP_MATCH_STATUS]: resetCourseMapMatchStatus,
    [REQUEST_HAZARDS]: requestHazards,
    [RECEIVE_HAZARDS]: receiveHazards,
    [RECEIVE_HAZARDS_FAILED]: receiveHazardsFailed,
    [REQUEST_HAZARDS_ON_COURSE]: requestHazardsOnCourse,
    [RESET_HAZARDS]: resetHazardsArray,
    [FETCH_ELEVATION_DATA_FOR_COURSE_POINTS_ON_CHINA_IMPORT_DONE]: updateElevationOnChinaImport,
    [ENABLE_LAP_BY_COURSE_POINTS]: enableLapByCoursePoints
};

export const getCourses = (state) => {
    return state.courses.entity;
};

export const getEditableCourseData = (state) => {
    return state.courses.editableCourseData;
};

export const getCourseElevationChartExpandedStatus = (state) => {
    return state.courses.elevationChart.courseElevationChartExpandedStatus;
};

export const getChartSelectedAreaStartValue = (state) => {
    return state.courses.elevationChart.selectionStart;
};

export const getChartSelectedAreaEndValue = (state) => {
    return state.courses.elevationChart.selectionEnd;
};

export const getMapBoundingBox = (state) => {
    return state.courses.mapBoundingBox;
};

export const getElevationChartSelectedGeoPoints = (state) => {
    return state.courses.elevationChart.selectedGeoPoints;
};

export const getCoursesListGeoPoints = (state) => {
    return state.courses.coursesListGeoPoints.items;
};

export const getCoursesListSpecificGeoPoint = (state, courseId) => {
    return state.courses.coursesListGeoPoints.items[courseId];
};

export const getCoursesListGeoPointsFetchingCourseIds = (state) => {
    return state.courses.coursesListGeoPoints.fetching;
};

export const isFetchingCourseDetails = (state) => {
    return state.courses.fetchingCourseDetails;
};

export const getIsSettingFavoriteCourseInProgress = (state) => {
    return state.courses.isSettingFavoriteCourseInProgress;
};

export const getChangingFavoriteCourseStatusFailed = (state) => {
    return state.courses.changingFavoriteCourseStatusFail;
};

export const getEditableCourseDrawingData = (state) => {
    return state.courses.editableCourseDrawingData;
};

export const getInitialCourseDataWithNoChanges = (state) => {
    return state.courses.initialCourseDataWithNoChanges;
};

export const getMapRouteFetchingStatus = (state) => {
    return state.courses.editableCourseDrawingData.mapRouteFetching;
};

export const getWebGatewayCourses = (state) => {
    return state.courses.webGatewayCourses;
};

export const getWebGatewayCoursesFilteredAndSorted = (state) => {
    let sortWebGatewayCourses =
        state.courses.webGatewayCourses && state.courses.webGatewayCourses.length
            ? [...state.courses.webGatewayCourses]
            : [];

    if (state.courses.courseListSortType && sortWebGatewayCourses && sortWebGatewayCourses.length) {
        sortWebGatewayCourses = sortListByFilterValue(sortWebGatewayCourses, state.courses.courseListSortType);
    }

    if (state.courses.courseListFilters && sortWebGatewayCourses && sortWebGatewayCourses.length) {
        sortWebGatewayCourses = filterCourseList(sortWebGatewayCourses, state.courses.courseListFilters);
    }

    if (state.courses.mapBoundingBox) {
        sortWebGatewayCourses = filterCourseListByMapBounds(sortWebGatewayCourses, state.courses.mapBoundingBox);
    }

    return sortWebGatewayCourses;
};

export const getIsDeleteCourseInProgress = (state) => {
    return state.courses.deleteCourseInProgress;
};

export const getDeleteCourseErrorStatus = (state) => {
    return state.courses.deleteCourseError;
};

export const coursesListIsFetching = (state) => state.courses.coursesListFetching;
export const coursesIsFetched = (state) => state.courses.coursesFetched;

export const coursesLinesIsFetching = (state) => state.courses.courseLinesFetching;

export const coursesDuplicateIsFetching = (state) => state.courses.courseDuplicateFetching;

export const getCourseElevationFetchingStatus = (state) => state.courses.courseElevationFetching;

export const getCourseRouteHistory = (state) => state.courses.courseRouteHistory;

export const getCourseRouteHistoryIndex = (state) => state.courses.courseRouteHistoryIndex;

export const getRunningCourses = (state) => {
    return Array.filter(state.courses.entity, (course) => {
        return course.activityType.typeId === 1 || course.activityType.parentTypeId === 1;
    });
};

export const getPaceProCourses = (state) => {
    return Array.filter(state.courses.entity, (course) => {
        return (
            (course.activityType.typeId === 1 || course.activityType.parentTypeId === 1) &&
            course.distanceInMeters > PaceProConstants.MIN_LENGTH &&
            course.distanceInMeters < PaceProConstants.MAX_LENGTH
        );
    });
};

export const getPowerGuidanceCourses = (state) => {
    return Array.filter(state.courses.entity, (course) => {
        return (
            course.activityType.parentTypeId === 2 &&
            course.distanceInMeters > PowerGuidanceConstants.MIN_LENGTH &&
            course.distanceInMeters < PowerGuidanceConstants.MAX_LENGTH
        );
    });
};

export const getGroupCourses = (state) => {
    return state.courses.group;
};

export const getFavoriteCourses = (state) => {
    return state.courses.favorite;
};

export const getFavoriteCoursesFilteredAndSorted = (state) => {
    let sortFavoriteCourses =
        state.courses.favorite && state.courses.favorite.length ? [...state.courses.favorite] : [];

    if (state.courses.courseListSortType && sortFavoriteCourses && sortFavoriteCourses.length) {
        sortFavoriteCourses = sortListByFilterValue(sortFavoriteCourses, state.courses.courseListSortType);
    }

    if (state.courses.courseListFilters && sortFavoriteCourses && sortFavoriteCourses.length) {
        sortFavoriteCourses = filterCourseList(sortFavoriteCourses, state.courses.courseListFilters);
    }

    if (state.courses.mapBoundingBox) {
        sortFavoriteCourses = filterCourseListByMapBounds(sortFavoriteCourses, state.courses.mapBoundingBox);
    }

    return sortFavoriteCourses;
};

export const getCourseListSetSortType = (state) => {
    return state.courses.courseListSortType;
};

export const getCourseListFilters = (state) => {
    return state.courses.courseListFilters;
};

export const getAvailableCoursePoints = (state) => {
    return state.courses.availableCoursePoints;
};

export const getImportedCourseData = (state) => {
    return state.courses.importedCourse;
};

export const getCoursePointSelection = (state) => {
    return state.courses.coursePointSelection;
};

export const getElevationChartHoverValue = (state) => {
    return state.courses.elevationChartHoverValue;
};

export const getFavoriteCoursesOfType = (state, courseTypeKey) => {
    return state.courses.favorite.filter((course) => {
        return course.activityType.typeKey === courseTypeKey;
    });
};

export const getPaceProFavoriteCourses = (state) => {
    return state.courses.favorite.filter((course) => {
        return (
            course.activityType.typeKey === PaceProConstants.COURSE_TYPE &&
            course.distanceInMeters > PaceProConstants.MIN_LENGTH &&
            course.distanceInMeters < PaceProConstants.MAX_LENGTH
        );
    });
};

export const getPowerGuidanceFavoriteCourses = (state) => {
    return state.courses.favorite.filter((course) => {
        return (
            PowerGuidanceConstants.COURSE_TYPE.includes(course.activityType.typeKey) &&
            course.distanceInMeters > PowerGuidanceConstants.MIN_LENGTH &&
            course.distanceInMeters < PowerGuidanceConstants.MAX_LENGTH
        );
    });
};

export const getCourse = (state, action) => {
    return state.courses.find((course) => {
        return course.id === action.courseId;
    });
};

export const getCourseDetail = (state, courseId) => {
    return state.courses.details[courseId] ? state.courses.details[courseId] : {};
};

export const getCoursesDetail = (state) => {
    return state.courses.details;
};

export default function courses(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const getCoursePointMarkerData = (state) => {
    return state.courses.coursePointMarkerData;
};

export const getNearbyCourses = (state) => {
    return state.courses.nearbyCourses;
};

export const getNearbyCoursesTotalSearchHits = (state) => {
    return state.courses.nearbyCoursesTotalSearchHits;
};

export const getBoundingBoxError = (state) => {
    return state.courses.boundingBoxError;
};

export const getNearbyCoursesListIsFetching = (state) => state.courses.nearbyCoursesFetching;

export const getThirdPartyConsumerInfo = (state, courseId) => {
    return courseId && state.courses.consumers[courseId]
        ? state.courses.consumers[courseId].applicationName
        : undefined;
};

export const getThirdPartyConsumerDetails = (state, courseId) => {
    return courseId && state.courses.consumers[courseId] ? state.courses.consumers[courseId] : undefined;
};

export const getClimbs = (state) => {
    return state.courses.climbs;
};

export const getCachedClimbs = (state) => {
    return state.courses.cachedClimbs;
};

export const getClimbsOnRouteOrCourse = (state) => {
    return state.courses.climbsOnRouteOrCourse;
};

export const getSecondaryClimbs = (state) => {
    return state.courses.secondaryClimbs;
};

export const getSecondaryClimbsIsFetching = (state) => {
    return state.courses.secondaryClimbsFetching;
};

export const getCourseMapMatchState = (state) => {
    return state.courses.mapMatchState;
};

export const getClimbsListFetching = (state) => {
    return state.courses.climbsListFetching;
};

export const getHazards = (state) => {
    return state.courses.hazards;
};

export const getHazardsFetching = (state) => {
    return state.courses.hazardsFetching;
};

export const isLapByCoursePointsEnabled = (state) => {
    return state.courses.lapByCoursePointsEnabled;
};
